import { z } from 'zod';
import { HttpErrorResponse } from '../../common/validation-error';
import { CmsModuleDefinitionSchema } from './content-module';
export const CmsModuleListItemSchema = z.object({
    title: z.string(),
    slug: z.string(),
    topic: z.string(),
    activitiesCount: z.number(),
    publishStatus: z.enum(['LIVE', 'ARCHIVED']),
    isProsumer: z.boolean(),
    updatedAt: z.string(),
});
export const GetCmsModuleParams = z.object({
    slug: z.string().min(1),
});
export const getCmsModulesRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/cms/modules',
    name: 'get-cms-modules',
    request: {},
    responses: { 200: z.array(CmsModuleListItemSchema) },
};
export const getCmsModuleRoute = {
    version: 1,
    method: 'GET',
    path: '/admin/cms/modules/{slug}',
    name: 'get-cms-module',
    request: { params: GetCmsModuleParams },
    responses: {
        200: CmsModuleDefinitionSchema,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
